import { appendDataToListTable, renderListError } from '../crud/shared.js';
import { PageTitle } from '../../components.js';
import { Page } from '../base.js';

class AdminsListRow {
  static props = ['href', 'email', 'role', 'verifiedAt', 'createdAt', 'userEmail'];
  static timl = `
    td
      a[href="{{ Props.href }}"] {{ Props.email }}
    td.pr-4 {{ Props.role }}
    td.table-col-100.pr-4[style="white-space:nowrap;"] {{ Props.verifiedAt }}
    td.table-col-100.pr-4[style="white-space:nowrap;"] {{ Props.createdAt }}
    td.table-col-100 {{ Props.userEmail }}
  `;
}

export class AdminsList extends Page {
  static timlComponents = {
    PageTitle
  };

  static timl = `
    a.list-view-add-button.create-button[href="/admins/create"] Invite admin
    <PageTitle title="Admins">
    table.resource-table[data-empty-title="No admins yet" data-empty-description="Invite someone to help manage your account." data-empty-action="Invite admin" data-empty-href="/admins/create"]
      thead
        th Email
        th.pr-4 Role
        th.table-col-100.pr-4 Verified At
        th.table-col-100.pr-4 Created At
        th.table-col-100 Created By
      tbody#admins-list-rows.fade
  `;

  static javascript() {
    API.get(API.resourceUrl('admins'))
      .then(response => {
        appendDataToListTable(
          '#admins-list-rows',
          response.data,
          AdminsListRow,
          this.mapItemToRowData
        );
      })
      .catch(error => renderListError('#admins-list-rows', error, 'Admins'));
  }

  static mapItemToRowData(item) {
    return {
      href: `${location.href}/${item.id}#${item.email || item.id}`,
      email: item.email || '',
      role: item.role || '—',
      verifiedAt: item.verifiedAt ? Util.formatDate(item.verifiedAt) : 'pending',
      createdAt: Util.formatDate(item.createdAt),
      userEmail: item.createdBy || ''
    };
  }
}
